import { render } from "./PersonalTutor.vue?vue&type=template&id=3bf7d26f&scoped=true"
import script from "./PersonalTutor.vue?vue&type=script&lang=js"
export * from "./PersonalTutor.vue?vue&type=script&lang=js"

import "./PersonalTutor.vue?vue&type=style&index=0&id=3bf7d26f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf7d26f"]])

export default __exports__